import React from "react";
import {
    HashRouter,
    Route,
    Routes,
} from "react-router-dom";
import { AppInitWrapper, SentinelLayout } from "./components";
import {
    LandingPage,
    NotFoundPage,
    //PermissionDeniedPage,
    OnboardingPage,
    TeamProfilePage,
} from "./pages";
import { SentinelController } from "src/core/controller";
import { TeamDetailPage } from "./pages/team-detail-page";
import { PackageDetailPage } from "./pages/package-detail-page";
import { PipelinePackagesPage } from "./pages/pipeline-packages-page";
import { DryRunPage } from "./pages/dry-run-page";
import { CRDashboardPage } from "./pages/cr-dashboard-page";
interface AppProps {
    sentinelController: SentinelController;
  }
export const App:React.FC<AppProps> = ({ sentinelController }) => {
    return (
        <AppInitWrapper>
            <HashRouter>
                <Routes>
                    <Route path="/" element={<SentinelLayout />}>
                        <Route index element={<LandingPage />} />
                        <Route path="dry-run" element={<DryRunPage sentinelController={sentinelController} />} />
                        <Route path="cr-dashboard/:teamName" element={<CRDashboardPage sentinelController={sentinelController} />} />
                        <Route path="onboard" element={<OnboardingPage sentinelController={sentinelController} />} />
                        <Route path="team">
                            <Route index element={<TeamProfilePage sentinelController={sentinelController} />} />
                            <Route path="details/:teamId" element={<TeamDetailPage sentinelController={sentinelController} />} />
                            <Route path="details/:teamId/pipeline/:pipelineName" element={<PipelinePackagesPage sentinelController={sentinelController} />} />
                            <Route path="details/:teamId/:packageId" element={<PackageDetailPage sentinelController={sentinelController} />} />
                        </Route>
                    </Route>
                    <Route path="/*" element={<NotFoundPage />} />
                </Routes>
            </HashRouter>
        </AppInitWrapper>
    );
};
export default App;